import type { DocumentViewportValue } from "@/features/document-viewport/types";
import type { AnnotationRecord } from "@/features/rev-collab/rev-collab-types";

export function getViewportContentCenter(viewport: DocumentViewportValue) {
  return {
    x:
      viewport.viewportPadding.left +
      (viewport.workspaceSize.width -
        viewport.viewportPadding.left -
        viewport.viewportPadding.right) /
        2,
    y:
      viewport.viewportPadding.top +
      (viewport.workspaceSize.height -
        viewport.viewportPadding.top -
        viewport.viewportPadding.bottom) /
        2,
  };
}

export function getAnnotationCenter(annotation: AnnotationRecord) {
  if (annotation.kind === "pin" || annotation.kind === "circle") {
    return {
      x: annotation.geometry.x ?? 0,
      y: annotation.geometry.y ?? 0,
    };
  }

  if (annotation.kind === "freehand" && annotation.geometry.points) {
    const xValues = annotation.geometry.points.filter((_, index) => index % 2 === 0);
    const yValues = annotation.geometry.points.filter((_, index) => index % 2 === 1);
    return {
      x: xValues.length > 0 ? (Math.min(...xValues) + Math.max(...xValues)) / 2 : 0,
      y: yValues.length > 0 ? (Math.min(...yValues) + Math.max(...yValues)) / 2 : 0,
    };
  }

  return {
    x: (annotation.geometry.x ?? 0) + (annotation.geometry.width ?? 0) / 2,
    y: (annotation.geometry.y ?? 0) + (annotation.geometry.height ?? 0) / 2,
  };
}
